/* Built In Imports */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';

/* External Imports */
import { Box } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';
import { useMediaQuery } from 'react-responsive';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
/* Internal Imports */
/* Components */

/**
 * Renders the ImageBannerAd Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.width
 * @param sectionContent.height
 * @param sectionContent.my
 * @param sectionContent.display
 * @param sectionContent.maxW
 * @returns {ReactElement} ImageBannerAd component
 */
const AwardsAndAccreditation = ({
    section, region, language
}) => {
    // console.log("section awards", section)
    const isMobile = useMediaQuery({ maxWidth: 767 });

    const NextArrow = props => {
        const { onClick } = props;
        return (
            <Box
                pos="absolute"
                top={{ base: "-80px", sm: "-80px", md: "-115px" }}
                right={{ base: "10px", sm: "10px", md: "40px" }}
                zIndex="10"
                cursor="pointer"
                bgSize="10px"
                bgColor="#fff"
                border="0"
                borderRadius="100%"
                w={{
                    base: "40px", md: "62px", lg: "62px"
                }}
                h={{
                    base: "40px", md: "62px", lg: "62px"
                }}
                boxShadow="0 0 10px rgba(0, 0, 0, 0.5)"
                bgPos="center"
                bgRepeat="no-repeat"
                color="transparent"
                bgImage={`url(${config.staticPath}/assets/images/right-arrow.svg)`}
                onClick={onClick}
            ></Box>
        );
    };

    const PrevArrow = props => {
        const { onClick } = props;
        return (
            <Box
                pos="absolute"
                top={{ base: "-80px", sm: "-80px", md: "-115px" }}
                right={{ base: "70px", sm: "70px", md: "120px" }}
                zIndex="10"
                cursor="pointer"
                bgSize="10px"
                bgColor="#fff"
                border="0"
                borderRadius="100%"
                w={{
                    base: "40px", md: "62px", lg: "62px"
                }}
                h={{
                    base: "40px", md: "62px", lg: "62px"
                }}
                boxShadow="0 0 10px rgba(0, 0, 0, 0.5)"
                bgPos="center"
                bgRepeat="no-repeat"
                color="transparent"
                bgImage={`url(${config.staticPath}/assets/images/left-arrow.svg)`
                }
                // className={`${classes["meetSlick-arrow"]} ${classes.meetPrevArrow}`}
                onClick={onClick}
            />
        );
    };

    const settings = {
        dots: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: false,
        infinite: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 834,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
        ],
        customPaging: function () {
            return (
                <Box
                    cursor="pointer"
                    display="inline-block"
                    w="12px"
                    h="12px"
                    m="-30px 0px"
                    bgColor="#cf4520"
                    borderRadius="50%"
                // className="bullet"
                ></Box>
            );
        },
        dotsClass: "slick-dots meet-dots",
    };

    return (
        <>
            <Box
                height={{ base: "540px", sm: "540px", md: "715px" }}
                padding={{
                    base: "52px 20px 50px 22px",
                    base: "52px 20px 50px 22px",

                    md: "75px 46px 107px 189px"
                }}
            >
                <Box
                    width="100%"
                    fontFamily="'FedraSansStd-A-medium', 'sans-serif'"
                    fontSize={{ base: '24px', md: '40px', lg: '40px' }}
                    lineHeight="1.25"
                    color="#28231E"
                >
                    <Box>
                        {section?.sectionContent[0]?.titleText.substring(0, 8)}
                    </Box>
                    <Box>
                        {section?.sectionContent[0]?.titleText.substring(9)}
                    </Box>

                </Box>

                <Box
                    float="left"
                    w="100%"
                    m={{
                        base: '37px 0px 39px 0px',
                        sm: '37px 0px 39px 0px',
                        md: '39px 0px 39px 0px',
                        lg: '39px 0px 39px 0px',
                    }}
                >
                    <Slider {...settings} m="0" display={"flex"}>
                        {section?.sectionContent[1]?.cards?.map((data, i) => {
                            return (
                                <Box
                                    display={"flex"}
                                    key={i}
                                    width={{ base: '151px', md: '325px' }}
                                    fontSize={{ base: '14px', md: '18px' }}
                                    textAlign={'center'}
                                >
                                    <Box
                                        bgColor={{ base: 'none', md: '#fff' }}
                                        padding={{ base: "", sm: "", md: "10px 0px" }}
                                        marginRight={{ base: "17px", sm: "17px", md: "60px" }}
                                        height={{ base: 'fit', md: '403px' }}
                                        width={{ base: "", sm: "", md: "325px" }}
                                    >
                                        <Box
                                            display={"flex"}
                                            justifyContent={"center"}
                                            alignItems={"center"}
                                            height={{ base: '133px', md: '225px' }}
                                        >
                                            <LazyLoadImageComponent
                                                alt={data?.thumbnail?.alt}
                                                title={data?.thumbnail?.title}
                                                src={data?.thumbnail?.url}
                                                maxW={{ base: '112px', md: '217px' }}
                                            />
                                        </Box>
                                        <Box
                                            display={"flex"}
                                            justifyContent={"center"}
                                            alignItems={"center"}
                                            marginTop={{ base: "15px", sm: "15px", md: "0px" }}
                                            className='awarddetail'
                                        >
                                            <StructuredTextParser
                                                w={{ base: 'fit', md: '270px' }}
                                                str={render(data.description)}
                                                textAlign={{ base: "left", sm: "left", md: "center" }}
                                                fontSize={{ base: '14px', md: '18px' }}
                                            />
                                        </Box></Box>
                                </Box>
                            );
                        })}
                    </Slider>
                    <style jsx global>{`
                        .slick-dots li {
                            opacity: 0.25;
                        }
                        .slick-dots li.slick-active {
                            opacity: 1;
                        }
                        .slick-track {
                            margin: 0 !important;
                        }
                        .awarddetail p {
                            font-family: FedraSansStd-book !important;
                        }
                        @media (max-width: 767px) {
                            .slick-dots {
                                bottom: 15px;
                            }
                        }
                        `}</style>
                </Box >

            </Box >
        </>
    );
};

export default AwardsAndAccreditation;
